import settings from '../config/settings';
import axios from './axios';

const { apiBaseURL } = settings;

export default class AuthApi {
  static login(email, password, staySignedIn) {
    return axios.post(`${apiBaseURL}/authenticate`, { email, password, staySignedIn });
  }

  static refreshToken(password) {
    return axios.post(`${apiBaseURL}/refresh-token`, { password });
  }

  static register(user) {
    return axios.post(`${apiBaseURL}/register`, user);
  }

  static getJoinData(token) {
    return axios.get(`${apiBaseURL}/join?${token}`);
  }

  static getWelcomeData(token) {
    return axios.get(`${apiBaseURL}/welcome?${token}`);
  }
}



// WEBPACK FOOTER //
// ./src/api/AuthApi.js